import { render, staticRenderFns } from "./ttshop_invoice.vue?vue&type=template&id=1a0f2a7e&scoped=true"
import script from "./ttshop_invoice.vue?vue&type=script&lang=js"
export * from "./ttshop_invoice.vue?vue&type=script&lang=js"
import style0 from "./ttshop_invoice.vue?vue&type=style&index=0&id=1a0f2a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f2a7e",
  null
  
)

export default component.exports